import isComingSoon from "../../../../helpers/isComingSoon";

const getIsEarlyAccessCategoryComingSoon = state =>
  isComingSoon({ earlyAccess: state.category.details?.earlyAccess });

export default getIsEarlyAccessCategoryComingSoon;
